import { z } from 'zod'
import { Model } from './architecture'

export const SubtitleValidation = z.object({
  value: z.string({ required_error: '[Subtitle] value is required' }),
})

export class Subtitle extends Model {
  static create({ value }: z.infer<typeof SubtitleValidation>) {
    SubtitleValidation.parse({ value })
    return new Subtitle(value, false)
  }

  static empty() {
    return new Subtitle('', true)
  }

  constructor(
    private readonly _value: string,
    private readonly _empty: boolean
  ) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  isEmpty() {
    return this._empty
  }

  toJSON() {
    return { value: this.value }
  }
}
